var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12643",
    "data-name": "Group 12643",
    transform: "translate(-924 -746)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11211",
    "data-name": "Group 11211",
    transform: "translate(924 746)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_60_28",
    "data-name": "Component 60 \\u2013 28",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M97.313,73.477a6.736,6.736,0,0,0-6.737,6.748v6.748A6.745,6.745,0,0,1,83.84,93.72H23.21a6.749,6.749,0,0,1-6.737-6.748V26.243A6.753,6.753,0,0,1,23.21,19.5h6.737a6.748,6.748,0,0,0,0-13.5H23.21A20.251,20.251,0,0,0,3,26.243V86.972a20.251,20.251,0,0,0,20.21,20.243H83.84a20.251,20.251,0,0,0,20.21-20.243V80.225A6.736,6.736,0,0,0,97.313,73.477Z",
    transform: "translate(-3 20.784)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M102.313,22.743A20.779,20.779,0,0,0,96.2,7.952C88.308.058,74.552.058,66.67,7.946l-9.041,9.022a4.909,4.909,0,0,0-.5.331c-.148.148-.2.337-.33.493L9.981,64.525A6.758,6.758,0,0,0,8,69.3V89.546a6.74,6.74,0,0,0,6.737,6.748h20.21a6.707,6.707,0,0,0,4.77-1.984l46.651-46.9a5.8,5.8,0,0,0,.5-.331c.148-.148.2-.351.344-.513L96.2,37.534A20.779,20.779,0,0,0,102.313,22.743ZM32.151,82.8H21.473V72.1l40.5-40.419L72.5,42.237ZM86.664,28l-4.655,4.676-10.5-10.513,4.675-4.669a7.577,7.577,0,0,1,10.482.007A7.429,7.429,0,0,1,86.664,28Z",
    transform: "translate(25.687 -2.03)",
    fill: "#333"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.9417d90bfb69b6b90eaad516cb5591ce.svg";
export { ForwardRef as ReactComponent };